export const TRACK_CHANGE_ENTITY_NAME = 'indskr_trackchanges';
export const BUILDING_ENTITY_NAME = 'msevtmgt_buildings';
export const IO_CONFIGURATION_ENTITY_NAME = 'indskr_ioconfigurations';